import { render, staticRenderFns } from "./update-carousel.vue?vue&type=template&id=2c613aa8&scoped=true"
import script from "./update-carousel.vue?vue&type=script&lang=ts"
export * from "./update-carousel.vue?vue&type=script&lang=ts"
import style0 from "./update-carousel.vue?vue&type=style&index=0&id=2c613aa8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c613aa8",
  null
  
)

export default component.exports